/**
 * ADD RSS FEED - SPECIFIC THIRD PARTIES TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import utils from './../../../utils/utilities';
import commonActions from './../../../api/Common.actions';
import LightSpinnerWrapper from '../../Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx';
import { DEFATULT_TABLE_PAGE_SIZE } from './../../../constants';

import InfiniteScrollTable from './../../../reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx';
import CustomTableBody from './../../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import TableSelectBox from './../../../reusable/TableSelectBox/TableSelectBox.index.jsx';
import SearchBox from './../../../reusable/SearchBox/SearchBox.index.jsx';
import CountBox from './../../../reusable/CountBox/CountBox.index.jsx';

import Modal from './../../../reusable/Modal/Modal.index.jsx';

import {
    CheckboxCell,
    LabelsCell,
    SimpleArrayCell
} from './../../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';
import reduxStore from "../../../reduxStore";

class SpecificThirdParties extends React.Component {

    constructor(props) {
        super(props);

        this.categoryOptions = [];

        this.pageSize = DEFATULT_TABLE_PAGE_SIZE;
        this.columnWidths = [3, 18, 11, 11, 11, 11, 13, 34];
        this.areCategoriesLoaded = false;
        this.isViewSelectedItemsMode = false;
        this.localTableDataStore = [];
        this.rowsModel = [];

        this.loadedSelectedThirdParties = false;
        this.state = {
            showNoResultsModal: false,
            selectedEntitiesLoaded: false,
            categoriesLoaded: false
        };

        this.filterByCategory = this.filterByCategory.bind(this);
        this.categorySelected = this.categorySelected.bind(this);
        this.updateUserCategoriesPrefs = this.updateUserCategoriesPrefs.bind(this);
        this.toggleSelectThirdParty = this.toggleSelectThirdParty.bind(this);
        this.getSelectedThirdParties = this.getSelectedThirdParties.bind(this);
        this.viewSelectedItems = this.viewSelectedItems.bind(this);
        this.clearSelectedItems = this.clearSelectedItems.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.deSelectAll = this.deSelectAll.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.createRowsModel = this.createRowsModel.bind(this);
        this.buildNoResultsModal = this.buildNoResultsModal.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.finishedAddingEntries = this.finishedAddingEntries.bind(this);

    }

    componentWillReceiveProps (newProps, newState) {
        this.rowsModel = this.createRowsModel();
    }

    componentDidMount() {
        if (this.props.state.selectedThirdPartiesIds && this.props.state.selectedThirdPartiesIds.length) {
            this.props.actions.getSelectedEntities(this.props.state.selectedThirdPartiesIds, (entities) => {
                this.props.actions.selectThirdParties(entities)
                this.props.actions.clearThirdPartyIds();
                this.setState({ selectedEntitiesLoaded: true });
            });
        } else {
            this.setState({ selectedEntitiesLoaded: true })
        }

        this.loadCategoriesPromise = this.props.actions.requestCategoryLabels().then((categories) => {
            this.categoriesIdFilters = utils.getSingleCategoryFilter(reduxStore.getState().user.preferences.filters.entitiesFilter, categories);
            this.rowsModel = this.createRowsModel();
            this.areCategoriesLoaded = true;
            this.filterByCategory(this.categoriesIdFilters); // Also triggers a URL params change and a count request
            this.setState({ categoriesLoaded: true });
        });
    }

    /*componentDidUpdate(prevProps, prevState) {

        // Refresh the table after retrieving the selected third parties from the server (Edit Feed functionality).
        if (!this.loadedSelectedThirdParties &&
            !utils.isDeepEqual(prevState.selectedThirdParties, this.state.selectedThirdParties)) {

            // this.props.actions.refreshTable();
            this.loadedSelectedThirdParties = true;
        }
    }*/

    createRowsModel() {
        let highlightProps = {};
        if (this.props.state.urlParams.searchFilter) {
            highlightProps.highlight = this.props.state.urlParams.searchFilter;
        }

        return [
            {
                fieldId:   'id',
                fieldType: CheckboxCell,
                props:     {
                    getSelectedItems: this.getSelectedThirdParties,
                    isAllSelected:    () => {return false;},
                    checkboxPrefix:   'add-rss-third-party',
                    propertyToCheck:  'id'
                }
            },
            {
                fieldId:   'companyTitle',
                fieldType: 'string',
                props: highlightProps
            },
            {
                fieldId:   'customerCompanyId',
                fieldType: 'string',
                props: highlightProps
            },
            {
                fieldId:   'companyName',
                fieldType: SimpleArrayCell,
                props: highlightProps
            },
            {
                fieldId:   'contextKeywords',
                fieldType: SimpleArrayCell,
                props: highlightProps
            },
            {
                fieldId:   'exclusionKeywords',
                fieldType: SimpleArrayCell,
                props: highlightProps
            },
            {
                fieldId:   'active',
                fieldType: 'boolean',
                format:    function(cellValue) {
                    return (
                        <span className={'third-party-listing__company-state-label' +
                        (cellValue ? ' state-active' : ' state-inactive')}>
                                <FormattedMessage id={cellValue ? 'General_CoreFunctionality_UIText_general.active' : 'General_CoreFunctionality_UIText_general.inactive'} />
                            </span>
                    );
                }
            },
            {
                fieldId:   'categoryIDs',
                fieldType: LabelsCell,
                props:     {
                    labels:        this.props.state.categoryNames,
                    noCloseButton: true
                }
            }
        ];

    }

    updateUserCategoriesPrefs(categoriesIdFilters) {
        if (categoriesIdFilters === "defaultAllCategories") {
            commonActions.updateUserFilters({
                entitiesFilter: {
                    type: "all_entities",
                    entitiesId: [],
                    categories: {
                        allCategories: true,
                        allUnassigned: true,
                        categoriesId: []
                    }
                }
            });
        } else {
            commonActions.updateUserFilters(
                {
                    entitiesFilter: {
                        type: "categories",
                        entitiesId: [],
                        categories: {
                            allCategories: false,
                            allUnassigned: false,
                            categoriesId: [categoriesIdFilters]
                        }
                    }
                });
        }
    }

    categorySelected(event) {
        this.updateUserCategoriesPrefs(event.target.value);
        this.filterByCategory(event.target.value);
    }

    filterByCategory(value) {
        let selectedCategory = value;
        /**
         this.categoriesIdFilters = reduxStore.getState().user.preferences.filters.categoriesIdFilters[0]
         is undefined because it is an empty array;
         when selectedCategory is undefined, !selectedCategory will be true
        **/
        let categoryIdFilter = null;
        if (selectedCategory === 'defaultAllCategories' || !selectedCategory ) {
            this.props.actions.changeTableUrlParams({
                categoryIdFilter: null
            });
        } else {
            this.props.actions.changeTableUrlParams({
                categoryIdFilter: selectedCategory
            });
            categoryIdFilter = selectedCategory
        }

        if (this.isViewSelectedItemsMode) {
            let items = utils.sortSelectedItemsArray(this.props.state.selectedThirdParties, 'companyTitle', 'asc');
            this.localTableDataStore = utils.filterArrayByField(categoryIdFilter, items);

            this.props.actions.refreshTable();

            this.props.actions.filterCountThirdParties(this.localTableDataStore.length);
        } else {
            this.props.actions.countEntries();
        }

    }

    toggleSelectThirdParty(event) {
        let checkboxId = event.target.getAttribute('data-checkbox-id');

        if (checkboxId) {
            let selectedItemIndex = utils.inArray(checkboxId, this.props.state.selectedThirdParties, 'id');

            if (selectedItemIndex === -1) {
                let table = this.refs.reviewCompaniesTableBody.getEntries();
                let itemIndex = utils.inArray(checkboxId, table, 'id');

                this.props.actions.selectThirdParties([table[itemIndex]]);
            } else {
                this.props.actions.deselectThirdParty(selectedItemIndex);
            }
        }
    }

    getSelectedThirdParties() {
        return this.props.state.selectedThirdParties;
    }

    selectAll() {
        this.props.actions.selectAll()
            .then(this.props.actions.refreshTable)
            .then(() => {

            });
    }

    deSelectAll() {

        this.props.actions.unSelectAll()
            .then(this.props.actions.refreshTable)
            .then(() => {

            });
    }

    viewSelectedItems() {
        this.isViewSelectedItemsMode = true;
        let items = utils.sortSelectedItemsArray(this.props.state.selectedThirdParties, 'companyTitle', 'asc');
        this.localTableDataStore = utils.filterArrayByField(this.props.state.urlParams.categoryIdFilter, items);
        this.props.actions.changeTableUrlParams({searchFilter: null});
        this.props.actions.refreshTable()
        this.props.actions.filterCountThirdParties(this.localTableDataStore.length);
    }

    clearSelectedItems() {
        this.isViewSelectedItemsMode = false;
        this.localTableDataStore = [];

        this.props.actions.selectThirdPartiesOption('specific-third-parties-section');
        this.props.actions.refreshTable();
        this.props.actions.countEntries();
    }

    handleSearch(value) {
        this.isViewSelectedItemsMode = false;
        this.props.actions.changeTableUrlParams({searchFilter: value, categoryIdFilter: null});
        this.props.actions.refreshTable();
        this.props.actions.countEntries();
    }

    handleClear() {
        this.isViewSelectedItemsMode = false;
        this.props.actions.changeTableUrlParams({searchFilter: null, categoryIdFilter: null});
        this.props.actions.refreshTable();
        this.props.actions.countEntries();
    }

    buildNoResultsModal() {
        if (this.state.showNoResultsModal == false) return null;
        let buttons = [
            {
                text:    <FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalContinueButton" />,
                primary: true,
                click:   this.resetFilters
            }
        ];

        let term = this.props.state.urlParams.searchFilter;

        return (
            <Modal buttons={buttons} closeButtonHandler={this.resetFilters}>
                <h2 className="modal-header"><FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalStatusMessage" /></h2>
                <div className="divider"></div>
                <div className="modal-check">
                    <FormattedMessage id="Entities_CoreFunctionality_UIText_search.entities.modalText" values={{search: <b>{term}</b>}} />
                </div>
            </Modal>
        );
    }

    resetFilters() {
        this.setState({ showNoResultsModal: false });
        this.handleClear();
    }

    finishedAddingEntries(response, tableRef) {
        if (tableRef.getNumberOfEntries() == 0 &&
            (this.props.state.urlParams.searchFilter &&
            !this.props.state.urlParams.categoryIdFilter)) {
            this.setState({ showNoResultsModal: true });
        }

        // This is necessary to do a force update so that the component re-renders
        // and shows the no results modal AND also for the case in which the spinner
        // needs to be hidden after selecting the "specific third parties" option.

    }

    render() {
        this.categoryOptions = [];

        for (let categoryId in this.props.state.categoryNames) {
            this.categoryOptions.push(
                <option key={'add-rss-category-option-' + categoryId} value={categoryId}>
                    {this.props.state.categoryNames[categoryId]}
                </option>
            );
        }

        return (
            <LightSpinnerWrapper isLoading={!(this.state.selectedEntitiesLoaded && this.state.categoriesLoaded)}>
                <div className="third-parties-sections specific-third-parties-section">
                    {this.buildNoResultsModal()}
                    <div className={'add-rss-error no-third-parties-error' +
                                        this.props.setErrorClass(['api.error.feed.noRiskEntities'])}>
                        <FormattedMessage id="RSS_Add_Error_addRssFeed.thirdParties.noThirdPartiesError" />
                    </div>

                    <div className="specific-third-parties-section__action-bar">
                        {!this.isViewSelectedItemsMode?
                        <TableSelectBox
                            size={this.props.state.selectedThirdParties.length}
                            viewSelectedFunction={this.viewSelectedItems}
                            clearSelectedFunction={this.clearSelectedItems}
                            selectAllFunction={this.selectAll}
                            deselectAllFunction={this.deSelectAll}
                            />
                            :
                            <TableSelectBox
                                size={this.props.state.selectedThirdParties.length}
                                viewSelectedFunction={this.viewSelectedItems}
                                clearSelectedFunction={this.clearSelectedItems}
                            />
                        }

                        <SearchBox handleSearch={this.handleSearch} handleClear={this.handleClear} initialValue={this.props.state.urlParams.searchFilter}/>
                        <div className="specific-third-parties-section__result-count">
                            <CountBox totalCount={this.props.state.totalCount} partialCount={this.props.state.filterCount} showAll={this.handleClear} />
                        </div>

                    </div>

                    {this.areCategoriesLoaded ?
                        <InfiniteScrollTable innerTable
                                             tableId="add-rss-page__third_parties_table"
                                             columnWidths={this.columnWidths}
                                             rowsModel={this.rowsModel}
                                             eventHandlers={
                                                    {
                                                        onClick: this.toggleSelectThirdParty
                                                    }
                                                 }>
                            <thead className="custom-table-head">
                                <tr>
                                    <th><input type="checkbox" className="visibility-hidden" /></th>
                                    <th><FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.thirdPartyTitle" /></th>
                                    <th><FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.uniqueThirdPartyId" /></th>
                                    <th><FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.nameVariants" /></th>
                                    <th><FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.contextKeywords" /></th>
                                    <th><FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.excludedKeywords" /></th>
                                    <th><FormattedMessage id="Entities_Edit_UIText_editThirdParty.statusLabel" /></th>
                                    <th>
                                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.show" />:
                                        &nbsp;
                                        <select id="add-rss-page__filter-by-category-dropdown"
                                                className="notranslate"
                                                value={this.props.state.urlParams.categoryIdFilter === null ?
                                                    'defaultAllCategories' : this.props.state.urlParams.categoryIdFilter}
                                                onChange={this.categorySelected}>
                                            <option value="defaultAllCategories">
                                                {this.props.intl.formatMessage({id: 'RSS_Add_UIText_addRssFeed.thirdParties.allCategories'})}
                                            </option>
                                            {this.categoryOptions}
                                        </select>
                                    </th>
                                </tr>
                            </thead>
                            <CustomTableBody ref="reviewCompaniesTableBody"
                                             url="/api/entities/active"
                                             startPageNumber="0"
                                             pageSize={this.pageSize}
                                             urlParams={this.props.state.urlParams}
                                             dataStore={this.isViewSelectedItemsMode ? this.localTableDataStore : null}
                                             lifecycleEvents={
                                                    {
                                                        finishedAddingEntries: this.finishedAddingEntries
                                                    }
                                                 } />
                        </InfiniteScrollTable> : null}
                </div>
            </LightSpinnerWrapper>
        );

    }

}

export default injectIntl(SpecificThirdParties);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/ThirdPartyRadioGroupOptions/ThirdParties.specificEntities.jsx